import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import { Grid, Paper, Typography } from "@mui/material";

import { useCookies } from "react-cookie";

export default function Token({ id }) {
	console.log("render token");
	const [state, setState] = useState({});


	const [cookies, setCookie, removeCookie] = useCookies();

	useEffect(() => {
		fetch("/anon/t/" + id)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				console.log("api/t", res);
				switch (res.res) {
					case "ok":
						console.log("api/t", res);
						setCookie("_bkeys", res.session_token, {
							path: "/", domain: window.location.hostname === "localhost"
								? "localhost" : ".bkeys.com"
						});
						setCookie("_bkuser", res.name, {
							path: "/", domain: window.location.hostname === "localhost"
								? "localhost" : ".bkeys.com"
						});
						//setState({ res: res.res, loaded: true });
						window.location.replace(res.r);
						break;
					case "err":
						setState({ ...state, loaded: true, ...res.payload, res: res.res });
						break;
					default:
						break;
				}
			});
	}, []);
	//if (!state.loaded) return false;
	return (
		<Grid style="height: 100%;" container alignItems="center" justifyContent="center">
			<Grid item>
				<Paper style="padding: 20px; margin: 5px;">
					{state.res === "err" && state.perim && <Typography variant="h5">Le lien soumis n'est plus valide :(</Typography>}
					{state.res === "err" && state.not_valid && <Typography variant="h5">Le lien soumis n'a pas été reconnu par Bkeys :(</Typography>}
					{state.res === undefined && <Typography variant="h5">Veuillez patienter une seconde ...</Typography>}
				</Paper>
			</Grid>
		</Grid>
	);
}
